import type { Popup } from '../models/Popup';

type PopupLocalizedFields = Pick<Popup, 'title' | 'title_en' | 'description' | 'description_en'>;

export function isEnglishLocale(language: string | undefined): boolean {
  return (language ?? '').toLowerCase().startsWith('en');
}

/** Título y descripción según el idioma activo de la app (es → campos ES, en → campos EN). */
export function getPopupLocalizedContent(
  popup: PopupLocalizedFields,
  language: string | undefined,
): { title: string; description: string } {
  const isEnglish = isEnglishLocale(language);

  if (isEnglish) {
    return {
      title: popup.title_en?.trim() || popup.title,
      description: popup.description_en?.trim() || popup.description,
    };
  }

  return {
    title: popup.title,
    description: popup.description,
  };
}
